import { mergeStyles } from '@uifabric/merge-styles';

const style = mergeStyles({
    whiteSpace: 'pre',
    display: 'inline-block',
    tabSize: '40px',
})

export const FormattedText = ({ text, cursor }: { text: string[][], cursor: boolean }) => {
    const [finished, mistaken, unfinished] = text

    let id = 0
    const render = (data: string[]) => (
        <>
            {data.map(char => {
                if (char === '\n') {
                    return <br/>
                } else {
                    return <div key={id++} className={style}>{char}</div>
                }
            })}
        </>
    )
    
    return (
        <div>
            <span>
                {render(finished)}
            </span>
            {mistaken.length > 0 && (
                <span className={mergeStyles({
                    color: '#f00',
                    background: '#f002',
                    outline: '1px solid #f004',
                })}>
                    {render(mistaken)}
                </span>
            )}
            {unfinished.length > 0 && (
                <span className={mergeStyles({
                    color: '#555',
                    background: '#5552',
                    outline: '1px solid #5554',
                })}>
                    {render(unfinished)}
                </span>
            )}
            {cursor && <div className={style}>_</div>}
        </div>
    )
}